import { partnerRestService } from "../services/PartnerRestService";
export const generateOTP = async (input) => {
  try {
    const res = await partnerRestService({
      method: "post",
      url: "otp/generate",
      data: input,
    });
    const response = res || {};
    return response;
  } catch (e) {
    return e;
  }
};
